module.exports = __webpack_public_path__ + "static/media/rig.4bbd7047.png";